// Theme toggle (DESIGN_SPEC §3): Conifer's 18px sun / moon in a 40px button. The icon shows the
// current mode; a click flips light ↔ dark and stores the choice. It sits in the nav row below
// 1300px and floats fixed at the top right, outside the 1180 column, from 1300px (components.css).
//   <ThemeToggle />
import { useTheme } from "@/hooks";

function Sun() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="4" fill="none" stroke="currentColor" strokeWidth="1.5" />
      <path
        d="M12 2.6V5.1M12 18.9V21.4M2.6 12H5.1M18.9 12H21.4M5.4 5.4L7.2 7.2M16.8 16.8L18.6 18.6M18.6 5.4L16.8 7.2M7.2 16.8L5.4 18.6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

function Moon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M15.5 4.5A8 8 0 1 0 15.5 19.5A6.2 6.2 0 1 1 15.5 4.5Z" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
  );
}

export function ThemeToggle() {
  const { theme, toggle } = useTheme();
  const next = theme === "dark" ? "light" : "dark";
  return (
    <button className="theme-toggle" type="button" aria-label={`Theme: ${theme}. Switch to ${next}.`} onClick={toggle}>
      {theme === "dark" ? <Moon /> : <Sun />}
    </button>
  );
}
